(function(){
  var root=document.getElementById('ahp'); if(!root) return;

  /* streak grids: 90 cells each, fixed patterns so they never look random-different on reload */
  var MISS=[1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,0,1,0,
            0,0,0,1,0,0,0,1,0,0,0,0,1,0,0,1,1,1,
            0,1,1,0,0,1,0,0,1,0,0,0,0,1,0,1,0,0,
            1,0,1,0,0,0,0,1,0,0,0,0,0,0,0,0,0,0,
            0,0,0,0,0,0,0,0,1,0,1,0,0,0,0,0,1,0];
  root.querySelectorAll('.grid').forEach(function(g){
    var miss = g.getAttribute('data-g')==='miss', h='';
    for(var i=0;i<90;i++){
      var on = miss ? MISS[i]===1 : (i!==37 && i!==71);
      h += '<i class="'+(on?'h':'')+'" style="transition-delay:'+(i*7)+'ms"></i>';
    }
    g.innerHTML=h;
  });

  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){
      es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
    },{threshold:.12});
    root.querySelectorAll('.rv').forEach(function(el){ io.observe(el); });
  } else {
    root.querySelectorAll('.rv').forEach(function(el){ el.classList.add('in'); });
  }

  var vids = root.querySelectorAll('.rvid');
  vids.forEach(function(v){
    var med = v.closest('.med'); if(!med) return;
    med.addEventListener('click', function(){ if(v.paused||v.ended){ v.play(); } else { v.pause(); } });
    v.addEventListener('play', function(){ med.classList.add('pg'); vids.forEach(function(o){ if(o!==v && !o.paused) o.pause(); }); });
    v.addEventListener('pause', function(){ med.classList.remove('pg'); });
    v.addEventListener('ended', function(){ med.classList.remove('pg'); });
  });
})();
